import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export default class DirectoryCard extends Component {
  constructor(props) {
    super(props);

    this.state = ({
      loading: '',
    });
  }

  render() {
    const {
      icon,
      title,
      subtitle,
      link,
    } = this.props;

    return (
      <div className="DirectoryCard">
        <Link to={link}>
          {title &&
            <h4>
              {icon && <FontAwesomeIcon icon={['fas', icon]} />}
              {title}
            </h4>
            }
          {subtitle && <h6>{subtitle}</h6>}
        </Link>
      </div>
    );
  }
}

DirectoryCard.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
  subtitle: PropTypes.string,
};

DirectoryCard.defaultProps = {
  subtitle: '',
  title: '',
  icon: '',
  link: '',
};
